module.exports = __webpack_public_path__ + "img/hub_art.335794be.svg";